/* eslint-disable react/prefer-stateless-function */
import React from "react";
import PropTypes from "prop-types";
import SimpleMap from "./SimpleMap";
import {
  formatCommaZeroDp,
  formatCurrBrief,
} from "../utils/dataHelpers/formatters";

const TOOLTIP_SCHEMA = [
  {
    fieldName: "County",
    accessor: "county",
    mainLabel: true,
  },
  {
    fieldName: "Loans per capita:",
    accessor: "loans_per_100k_people",
    formatter: formatCommaZeroDp,
  },
  {
    fieldName: "Total loans:",
    accessor: "loan_count",
    formatter: formatCommaZeroDp,
  },
  {
    fieldName: "Total loan amount:",
    accessor: "total_loan_amt",
    formatter: formatCurrBrief,
  },
];

class Body extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <div className="body__container">
        <SimpleMap
          geoData={data.geoData}
          csvData={data.csvData}
          colorAccessor="loans_per_100k_people"
          csvJoinAccessor="county"
          tooltipSchema={TOOLTIP_SCHEMA}
          legendTitle="Loans per 100,000 people"
        />
      </div>
    );
  }
}

Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Body;
